import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

import Home from './Main/Pages/Home'
import Auth from './Main/Pages/Auth'
import Reviews from './Main/Pages/Reviews'
import Developer from './Main/Pages/Developer'
import WorkSpace from './Main/Pages/WorkSpace'
import Dashboard from './Main/Pages/Dashboard'
import ProjectSettings from './Main/Pages/ProjectSettings'
import UserProfile from './Main/Pages/UserProfile'

import Protected from './Main/CommonComponents/Protected'
import 'bootstrap/dist/css/bootstrap.min.css';
import PageNotFound from './Main/CommonComponents/PageNotFound'
import CheckEmailVerification from './Main/CommonComponents/CheckEmailVerification'
import FullScreenLoaderAnimation from './Main/CommonComponents/FullScreenLoaderAnimation'
import { WakeUpService, WakeUpHeavyScriptsService } from "./Services/DjangoServices"

function App() {
  useEffect(() => {
    WakeUpHeavyScriptsService()
    WakeUpService().then((result) => {
      result.json().then((data) => {
        console.log(data)
        if ("token_expired" in data) {
          window.localStorage.removeItem('auth-token');
          window.location.replace('/');
        }
      });
    });
  }, []);

  return (
    <Router>
      <FullScreenLoaderAnimation with_time={2000}/>
      <Switch>
        <Route exact path="/auth" render={(props) => <Auth {...props} />}>
        </Route>
        <Route exact path="/workspace">
          <Protected component={WorkSpace} />
        </Route>
        <Route path="/project">
          <Protected component={Dashboard} />
        </Route>
        <Route path="/settings">
          <Protected component={ProjectSettings} />
        </Route>
        <Route exact path="/user_profile">
          <Protected component={UserProfile} />
        </Route>
        <Route exact path="/reviews">
          <Reviews />
        </Route>
        <Route exact path="/Developer-Mohit_Patidar">
          <Developer />
        </Route>
        <Route exact path="/">
          <Home />
        </Route>
        <Route exact path="/auth/verify_email/:username/:token">
          <CheckEmailVerification />
        </Route>
        <Route component={PageNotFound} />
      </Switch>
    </Router>
  );
}

export default App;
